import React, { useState, useEffect } from 'react'
import axios from 'axios'
import Homenav from '../homenav'
import MenuModal from './menuModal'
import { Link } from 'react-router-dom'
import config from '../../variables/config'
import _ from 'lodash'
import Loading from 'react-spinners/ClipLoader'

import './menu.scss'

export default function index() {
  // order filter can be 'uncompleted' 'completed' or 'all'
  const [loading, setLoading] = useState(false)
  const [activeMenuFilter, setActiveMenuFilter] = useState(null)
  const [menuData, setMenuData] = useState([])
  const [allMenuData, setAllMenuData] = useState([])
  const [menuModal, setMenuModal] = useState(null)
  const [deleteConfirm, setDeleteConfirm] = useState(null)
  const [triggerRefetch, setTriggerRefetch] = useState(false)
  const domain = config.serverURL + '/menuItems'
  const token = JSON.parse(window.localStorage.getItem('userData')).token
  const categories = [
    'Breakfast',
    'Pizzas',
    'Hot Food',
    'Jacket Potatoes',
    'Burgers',
    "Kid's Menu",
    'Paninis',
    'Omelettes',
    'Wraps',
    'Sandwiches & Baguettes',
    'Pastries & Cakes',
    'Snacks',
    'Drinks',
    'Cold Drinks'
  ]

  useEffect(() => {
    let filteredData = allMenuData
    if (activeMenuFilter && activeMenuFilter !== 'Filter by menu category') {
      filteredData = allMenuData.filter(
        item => item.categories.indexOf(activeMenuFilter) !== -1
      )
    }

    setMenuData(filteredData)
    setDeleteConfirm(null)
  }, [allMenuData, activeMenuFilter])

  useEffect(() => {
    setTriggerRefetch(false)
    fetchOrderData()
    setDeleteConfirm(null)
  }, [triggerRefetch])

  async function fetchOrderData() {
    setLoading(true)
    try {
      const response = (await axios.get(`${domain}?token=${token}`)).data

      setAllMenuData(response)
      //   const menuCategories = _.uniq(
      //     _.flattenDeep(response.map(item => item.categories))
      //   ) // If you ever need to have dynamically generated menu categories
    } catch (err) {
      alert("Couldn't fetch menu data from server...")
    }
    setLoading(false)
  }

  async function handleDelete(index) {
    if (deleteConfirm !== index) {
      setDeleteConfirm(index)
    } else {
      setLoading(index)
      try {
        const response = (await axios.delete(
          `${domain}/${menuData[index].id}?token=${token}`
        )).data
        setTriggerRefetch(true)
      } catch (err) {
        alert("Couldn't reach the server...")
      }
      setLoading(false)
    }
  }

  async function setAvailability(index) {
    const updateData = {
      ...menuData[index],
      unavailable: !menuData[index].unavailable
    }

    try {
      const response = (await axios.patch(
        `${domain}/${menuData[index].id}?token=${token}`,
        updateData
      )).data
      setTriggerRefetch(true)
    } catch (err) {
      alert("Couldn't reach the server...")
    }
  }

  return (
    <>
      <Homenav />
      <div className="menuContainer">
        <div className="headerContainer">
          <h1>Edit Menu</h1>
          <select onChange={e => setActiveMenuFilter(e.target.value)}>
            <option value={null}>Filter by menu category</option>
            {categories.map(item => (
              <option key={item} value={item}>
                {item}
              </option>
            ))}
          </select>
          <button onClick={() => setMenuModal({ id: 'new' })}>
            Add Menu Item
          </button>
          <Link to="/">
            <button className="backButton">Go Back</button>
          </Link>
        </div>
        <div className="menuList">
          {menuData.map((item, index) => (
            <div
              className={item.unavailable ? 'menuItem unavailable' : 'menuItem'}
              key={item.id}>
              <li>
                <h3>{item.name}</h3>
                <p>
                  {item.desc} <br />
                  Price: £{(item.price / 100).toFixed(2)}
                </p>
              </li>
              <div className="actionButtons">
                <button className="edit" onClick={() => setMenuModal(item)}>
                  Edit
                </button>
                <button
                  onClick={() => handleDelete(index)}
                  className={
                    deleteConfirm === index ? 'deleteConfirm delete' : 'delete'
                  }>
                  {deleteConfirm === index ? 'Sure?' : 'Delete'}
                  {loading === index && (
                    <Loading
                      loading={true}
                      size={20}
                      color="lightBlue"
                      css={{ marginLeft: '10px' }}
                    />
                  )}
                </button>
                <button
                  className="available"
                  onClick={() => setAvailability(index)}>
                  {!item.unavailable ? 'Set Unavailable' : 'Set Avaiable'}
                </button>
              </div>
            </div>
          ))}
          {menuModal && (
            <MenuModal
              modalData={menuModal}
              setMenuModal={setMenuModal}
              setTriggerRefetch={setTriggerRefetch}
            />
          )}
        </div>
      </div>
    </>
  )
}
